import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-space-25"
}
const _hoisted_2 = {
  key: 1,
  style: {"height":"300px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "carousel" }
const _hoisted_5 = { class: "viewport" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { id: "slider-nav-set" }
const _hoisted_8 = { class: "slider-nav-arrow" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex-center" }
const _hoisted_11 = {
  class: "img-area pb-1 px-4 py-4",
  style: {"background-color":"rgba(var(--primary-color-rgb), 0.5)","background":"url('/public/images/bg-color-square.png')","background-size":"cover"}
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "secondary-font text-black mt--4 mb-3" }
const _hoisted_14 = { class: "container-small" }
const _hoisted_15 = { class: "grid-web3" }
const _hoisted_16 = { class: "w-100p flex-center" }

import axios from 'axios';
import { onMounted, onUnmounted, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { inject } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MarketView',
  setup(__props) {

const BACKEND_URL = inject('BACKEND_URL');
const router = useRouter();
const layout = ref('none');
const loading = ref(false);
const errorMessage = ref('');
const startupInfos = reactive({
    banners: [] as any[],
    top_categories: [] as any[],
    top_produits: [] as any[],
})

onMounted(() => {
  layout.value = router.currentRoute.value.meta.layout as string || 'none';
  doGetStartupInfos().then(() => {
    startAutoSlide();
  });
});

onUnmounted(() => {
  stopAutoSlide()
})

async function doGetStartupInfos() {
    try {
        loading.value = true;
        errorMessage.value = '';
        const httpResponse = await axios.get(`/market/startup_infos`);
        Object.assign(startupInfos, httpResponse.data);
    } catch(error: any) {
        errorMessage.value = error.message;
    } finally {
        loading.value = false;
    }
}

const current = ref(0);
let timer: any = null;
function goTo(index: number) {
    current.value = index;
    resetTimers();
}

function next() {
    current.value = (current.value + 1) % startupInfos.banners.length;
}

function startAutoSlide() {
  timer = setInterval(() => {
    next()
  }, 4000)
}

function stopAutoSlide() {
  if (timer) {
    clearInterval(timer)
  }
}

function resetTimers() {
    clearInterval(timer);
    timer = setInterval(() => {
        next()
    }, 4000);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_market_card_product = _resolveComponent("market-card-product")!

  return (_openBlock(), _createElementBlock("main", null, [
    (layout.value == 'none')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "loader dark" }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "track",
                style: _normalizeStyle({ transform: `translateX(-${current.value * 100}%)` })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.banners, (banner, index) => {
                  return (_openBlock(), _createElementBlock("img", {
                    key: index,
                    src: _unref(BACKEND_URL) + '/assets/market_banners/1000/' + banner,
                    class: "slide-carousel"
                  }, null, 8, _hoisted_6))
                }), 128))
              ], 4)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.banners, (banner, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass(["slide", {active: index === current.value}]),
                    key: 'banner_nav_' + index,
                    onClick: ($event: any) => (goTo(index))
                  }, null, 10, _hoisted_9))
                }), 128))
              ])
            ])
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.top_categories, (category, index) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                to: (layout.value == 'frontoffice' ? '/front/market/produits' : '/market/produits') + '?categorie=' + category.id,
                class: "card-product px-5",
                style: {"width":"12%"},
                key: 'category_' + index
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("img", {
                      src: _unref(BACKEND_URL) + '/assets/market_categories/300/' + category.image,
                      class: "img mt-3"
                    }, null, 8, _hoisted_12),
                    _createElementVNode("h5", _hoisted_13, _toDisplayString(category.nom), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
          _createElementVNode("section", _hoisted_14, [
            _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "secondary-font mb-6 text-center" }, "Produits populaires", -1)),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.top_produits, (item, index) => {
                return (_openBlock(), _createBlock(_component_market_card_product, {
                  key: index,
                  produit: item,
                  layout: layout.value
                }, null, 8, ["produit", "layout"]))
              }), 128))
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_router_link, {
                to: layout.value == 'frontoffice' ? '/front/market/produits' : '/market/produits'
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("button", { class: "btn grey" }, [
                    _createElementVNode("span", null, "  Voir plus de produits"),
                    _createElementVNode("img", {
                      src: "/public/icons/icon-arrow-right.svg",
                      class: "btn-icon icon-black ml-5 mr-0",
                      alt: ""
                    })
                  ], -1)
                ]))]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "clear-both h-60" }, null, -1))
  ]))
}
}

})